(function () {
  function moveWishlistButton() {
    const wishlistBlock = document.querySelector(".shopify-app-block:has(wishlist-button-block)");
    const mediaGallery = document.querySelector("media-gallery");

    if (!wishlistBlock || !mediaGallery) return;

    wishlistBlock.removeAttribute("style");
    wishlistBlock.classList.add("wishlist-in-gallery");
    mediaGallery.appendChild(wishlistBlock);
  }

  function waitForWishlistLoad() {
    const wishlistButton = document.querySelector("wishlist-button-block");

    if (!wishlistButton) {
      setTimeout(waitForWishlistLoad, 200);
      return;
    }

    if (wishlistButton.hasAttribute("wk-loaded")) {
      moveWishlistButton();
      return;
    }

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === "attributes" && mutation.attributeName === "wk-loaded") {
          observer.disconnect();
          moveWishlistButton();
          return;
        }
      }
    });

    observer.observe(wishlistButton, { attributes: true });

    setTimeout(() => {
      observer.disconnect();
      moveWishlistButton();
    }, 5000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", waitForWishlistLoad);
  } else {
    waitForWishlistLoad();
  }
})();
